module.exports = __webpack_public_path__ + "static/media/Fire_Long_V2.fb11634e.png";